<h5 mat-dialog-title>{{ 'AddTimeOffType' | translate: {Default: 'Add Time Off Type'} }}</h5>

<mat-dialog-content>
    <app-form-generator
        [formId]="formId"
        [formData]="formData"
        [emitFormDataTrigger]="getFormData"
        (emitFormData)="formDataEmitted($event)"
        (emitFormStatus)="formStatusUpdated($event)"
        (emitFormPristine)="formPristineEmitted($event)"
    ></app-form-generator>

    <div class="form-section-title">
        <h6>{{ 'TimeOffIcon' | translate: {Default: 'Time Off Icon'} }}</h6>
    </div>
    <div class="k-mb-3">
        <div *ngIf="filePath && filePath !== ''; else noImage">
            <img [src]="filePath" class="timeoff-type-icon" alt="Time off type icon">
        </div>
        <ng-template #noImage>
            <div class="no-image"></div>
        </ng-template>
    </div>

    <div class="k-mb-3">
        <button type="button" mat-raised-button appPreventDoubleClick (throttledClick)="fileInput.click()">Choose File</button>
        <input hidden type="file" accept="image/*" #fileInput (change)="imagePreview($event)"/>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-button appPreventDoubleClick (throttledClick)="cancel()" class="k-mr-2">
        {{ 'Cancel' | translate: {Default: 'Cancel'} }}
    </button>
    <button
        type="button"
        mat-flat-button
        setColor="primaryColour"
        color="primary"
        appPreventDoubleClick
        (throttledClick)="getFormData = !getFormData"
        [disabled]="!formValid"
    >
        {{ 'Save' | translate: {Default: 'Save'} }}
    </button>
</mat-dialog-actions>

